export const reportResources = {
  'reports.withinSLA': 'Within SLA',
  'reports.smallSLAMiss': '1 Day Late',
  'reports.mediumSLAMiss': '2 Days Late',
  'reports.largeSLAMiss': '3+ Days Late',
  'reports.performance': 'Performance',
  'reports.orderCount': 'Order Count',
  'reports.orderPercentage': 'Order %',
  'reports.orderToShip': 'Order to Ship',
  'reports.orderToDeliver': 'Order to Deliver',
  'reports.shipToDeliver': 'Ship to Deliver',
  'reports.dateStartHelp': 'The starting bound of your report data',
  'reports.dateEndHelp': 'The ending bound of your report data',
  'reports.dateAggregatorHelp': 'How your report data aggregated. e.g. I would like to see a breakdown of data by day.',
  'reports.fcSelectHelp':
    'The Fulfillment Center that the report is generated for or "All" if the report encompasses all FCs.',
  'reports.editParamsStep': 'Click here to edit your currently selected report params',
  'reports.selectDateRange': 'Select Date Range',
  'reports.selectFC': 'Select an FC',
  'reports.allFCs': 'All FCs',
  'reports.customRange': 'Custom Range',
  'reports.datePresets.yesterday': 'Yesterday',
  'reports.datePresets.weekToDate': 'Week to Date',
  'reports.datePresets.pastWeek': 'Trailing Week',
  'reports.datePresets.previousWeek': 'Previous Whole Week',
  'reports.datePresets.monthToDate': 'Month to Date',
  'reports.datePresets.pastMonth': 'Trailing Month',
  'reports.datePresets.previousMonth': 'Previous Whole Month',
  'reports.datePresets.pastYear': 'Trailing Year',
  'reports.datePresets.previousYear': 'Previous Whole Year',
  'reports.datePresets.yearToDate': 'Year to Date',
  'reports.datePresets.customRange': 'Custom Range',
  'reports.hour': 'Hour',
  'reports.day': 'Day',
  'reports.week': 'Week',
  'reports.month': 'Month',
  'reports.year': 'Year',
};
export type ReportResourceKey =
  | 'reports.withinSLA'
  | 'reports.smallSLAMiss'
  | 'reports.mediumSLAMiss'
  | 'reports.largeSLAMiss'
  | 'reports.performance'
  | 'reports.orderCount'
  | 'reports.orderPercentage'
  | 'reports.orderToShip'
  | 'reports.orderToDeliver'
  | 'reports.shipToDeliver'
  | 'reports.dateStartHelp'
  | 'reports.dateEndHelp'
  | 'reports.dateAggregatorHelp'
  | 'reports.fcSelectHelp'
  | 'reports.editParamsStep'
  | 'reports.selectDateRange'
  | 'reports.selectFC'
  | 'reports.allFCs'
  | 'reports.customRange'
  | 'reports.datePresets.yesterday'
  | 'reports.datePresets.weekToDate'
  | 'reports.datePresets.pastWeek'
  | 'reports.datePresets.previousWeek'
  | 'reports.datePresets.monthToDate'
  | 'reports.datePresets.pastMonth'
  | 'reports.datePresets.previousMonth'
  | 'reports.datePresets.pastYear'
  | 'reports.datePresets.previousYear'
  | 'reports.datePresets.yearToDate'
  | 'reports.datePresets.customRange'
  | 'reports.hour'
  | 'reports.day'
  | 'reports.week'
  | 'reports.month'
  | 'reports.year';
